import { reactive } from "vue";

export const store = reactive({
	activeSubmenu: null,
	activeToggle: null,
	inactiveToggle: null,
	searchLabelVacancies: "Zoek in vacatures",
	searchTerm: null,
	storyTeaserFallbackImage: "images/jsconsultancy-logo.svg",
	newsTeaserFallbackImage: "images/jsconsultancy-logo-diap.svg",
	teamTeaserFallbackImage: "images/jsconsultancy-logo.svg",
	endpoints: {
		news: "/wp-json/wp/v2/news",
		story: "/wp-json/wp/v2/story",
		team: "/wp-json/wp/v2/team",
		vacancy: "/wp-json/wp/v2/vacancy",
	},
	filterLabels: {
		"work-province": "In welke provincie wil je werken?",
		discipline: "Vakgebied",
		"weekly-hours": "Uren per week",
		education: "Opleidingsniveau",
		"work-experience": "Werkervaring",
		"working-method": "Werkvorm",
		"contract-type": "Dienstverband",
	},
});
